<template>
  <div style="padding: 15px;background: #fff;">
    <!-- 工具栏 -->
    <div class="table-page-search-wrapper" style="margin-bottom:10px;">
      <a-form layout="inline">
        <a-form-item :wrapper-col="{ span: 30 }">
          <a-input
            placeholder="企业名称查找"
            @change="changeSearchText"
            style="width:150px"
          />
        </a-form-item>

        <a-form-item>
          <a-button
            type="primary"
            style="margin-left: 10px;"
            @click="searchList"
          >
            <a-icon type="search" />
            查询
          </a-button>
          &emsp;
        </a-form-item>
        <a-button
          type="primary"
          style="float:right;margin-top:4px;"
          @click="showEnterpriseModal('add')"
        >
          <a-icon type="plus" />
          添加企业
        </a-button>
      </a-form>
    </div>

    <!-- 表格 -->
    <a-table
      :columns="columns"
      :dataSource="tableData"
      :pagination="pagination"
      :loading="tableLoading"
    >
      <span slot="action" slot-scope="item">
        <a href="javascript:;">详情</a>
        <a-divider type="vertical" />
        <a href="javascript:;" @click="showEnterpriseModal('edit', item)"
          >修改</a
        >
      </span>
    </a-table>

    <!-- 模态框 -->
    <add-enterprise-modal
      :show-modal="showAddModalFlag"
      @cancel="handleAddModalCancel"
      @submit="handleAddModalSubmit"
      :confirmLoading="addModalConfirmLoading"
      :addInfo="addModelInfo"
      :submitType="submitType"
    ></add-enterprise-modal>
  </div>
</template>
<script>
import { getEnterpriseList, addEnterprise, editEnterprise } from '@/apis/enterprise'
import addEnterpriseModal from './tpl/add-edit-enterprise'

const columns = [{
  title: '企业名称',
  dataIndex: 'name',
  key: 'name'
}, {
  title: '联系人',
  dataIndex: 'contactPerson',
  key: 'contactPerson'
}, {
  title: '联系电话',
  key: 'contactPhone',
  dataIndex: 'contactPhone'
}, {
  title: '操作',
  key: 'action',
  scopedSlots: { customRender: 'action' }
}]

export default {
  data () {
    return {
      tableData: [],
      columns,
      tableLoading: false,
      pagination: {
        onChange: (page, pageSize) => {
          this.pagination.current = page
          this.pagination.pageSize = pageSize
          this._getEnterpriseList()
        },
        total: 0,
        pageSize: 12,
        current: 1,
        size: 'middle',
        showTotal: total => `共 ${total} 条`,
        pageSizeOptions: ['12', '24', '36', '48'],
        defaultPageSize: 12,
        showSizeChanger: true,
        onShowSizeChange: (current, pageSize) => {
          this.pagination.pageSize = pageSize
          this.pagination.current = 1
          this._getEnterpriseList()
        }
      },
      searchText: '',
      // 模态框
      showAddModalFlag: false,
      addModalConfirmLoading: false,
      submitType: 'add',
      addModelInfo: {
        name: '',
        contactPerson: '',
        contactPhone: ''
      }
    }
  },

  methods: {
    // 添加 -编辑 -企业模态框
    handleAddModalCancel () {
      this.showAddModalFlag = false
    },
    handleAddModalSubmit (form) {
      form.validateFields(
        (err, values) => {
          if (!err) {
            this.addModalConfirmLoading = true

            let params = {
              name: values.name,
              contacts: values.contactPerson,
              phone: values.contactPhone
            }

            if (this.submitType === 'add') {
              addEnterprise(params).then(res => {
                if (res.data.state === 1) {
                  this.$message.success('添加成功')
                  this.addModalConfirmLoading = false
                  this.showAddModalFlag = false
                }
                this.pagination.current = 1
                this._getEnterpriseList()
              })
            } else {
              editEnterprise(
                Object.assign(params, { id: values.id })
              ).then(res => {
                if (res.data.state === 1) {
                  this.$message.success('修改成功')
                  this.showAddModalFlag = false
                }
                this.addModalConfirmLoading = false
                this._getEnterpriseList()
              })
            }
          }
        }
      )
    },
    showEnterpriseModal (type, data) {
      this.showAddModalFlag = true
      if (type === 'add') {
        // 新增
        this.addModelInfo = {
          name: '',
          contactPerson: '',
          contactPhone: ''
        }
        this.submitType = 'add'
      } else if (type === 'edit') {
        // 编辑
        this.addModelInfo = {
          name: data.name,
          contactPerson: data.contactPerson,
          contactPhone: data.contactPhone,
          id: data.id
        }
        this.submitType = 'edit'
      }
      this.addModalConfirmLoading = false
    },
    // 检索
    changeSearchText (e) {
      this.searchText = e.target.value
    },
    searchList () {
      this.pagination.current = 1
      this._getEnterpriseList()
    },
    // 获取企业列表
    _getEnterpriseList () {
      this.tableLoading = true
      getEnterpriseList({
        pageIndex: this.pagination.current,
        pageSize: this.pagination.pageSize,
        search: this.searchText
      }).then(res => {
        const result = res.data.attribute
        this.pagination.total = result.count
        this.tableData = []
        result.rows.forEach((item, index) => {
          this.tableData.push({
            key: item.id,
            id: item.id,
            name: item.name,
            contactPerson: item.contacts,
            contactPhone: item.phone
          })
        })
        this.tableLoading = false
      })
    }
  },

  created () {
    this._getEnterpriseList()
  },
  components: {
    addEnterpriseModal
  }

}
</script>
<style lang="less" scoped>
</style>
